import React, { Component } from 'react';
import { Toast, Modal, Button, Tag } from 'antd-mobile'
import { Icon, Popover } from 'antd';
import * as services from '../projects/services';
import { createBrowserHistory } from "history";
import $ from "jquery";
import './style.less';
const history = createBrowserHistory();
let TabTitlesrc = null;
let TabTitlnum = [];
let tnum = 0;
let cmnum = 80;
export class Customgy extends Component {
    constructor(props) {
        super(props);
        TabTitlesrc = this.props.TabTitle;
        this.state = {
            TabTitle: this.props.TabTitle,
            TabItem: this.props.TabItem,
            cardid: this.props.cardid,
            packageid: this.props.packageid,
            mcno: this.props.mcno,
            stylenum: 0,
            checknum: 0,
            checkprice: 0,
            total: 0,
            checkItem: this.props.checkItem,
            modal1: false,
            MinconSumption: null,
            tablength: this.props.TabTitle.length
        }
        cmnum = this.props.packageid === 0 ? 80 : 60;
    }
    componentDidMount() {
        //获取体检中心是否自定义配置 
        services.GetMidcailConfig(this.props.mcno, '').then(datam => {
            if (datam.status === 0) {
                let minconsumption = datam.result.minconsumption;
                this.setState({ 'MinconSumption': minconsumption });
            } else {
                Toast.offline(datam.message, 2);
            }
        })
        for (let i = 0; i < TabTitlesrc.length; i++) {
            if (TabTitlesrc[i].num !== 0) {
                TabTitlnum.push(i);
            }
        }
        let checkprice = 0;
        checkprice = this.state.checkItem.reduce((pre, cur) => {
            return pre + cur.marketprice;
        }, 0);
        this.setState({ checkprice: checkprice, total: this.state.checkItem.length });
        window.addEventListener('scroll', this.handleScroll);
        document.getElementById('reftab').addEventListener('scroll', this.handleScroll);
    }
    //必选项目添加互斥


    handleScroll() {
        let latoutNode = document.getElementById("tabbox");
        for (var i = 0; i < TabTitlnum.length - 1; i++) {
            if (!!$("#t" + TabTitlnum[i]).offset() && $("#t" + (TabTitlnum[i + 1])).offset()) {
                if (window.scrollY > $("#t" + TabTitlnum[i]).offset().top - 172 && window.scrollY < $("#t" + (TabTitlnum[i + 1])).offset().top - 172) {
                    latoutNode.scrollTop = 70 * tnum;
                    tnum = TabTitlnum[i];
                    $("#tabbox .title").removeClass('checked');
                    $("#tabbox #tk" + TabTitlnum[i]).addClass('checked');
                    return false;
                }
            }
        }
    }
    onTab = (num, e) => {
        this.setState({ stylenum: num });
        tnum = num;
        var arrGet = $.inArray(num, TabTitlnum);
        if (this.props.packageid === 0) {
            $("#reftab").animate({ scrollTop: $("#t" + num).offset().top + $("#reftab").scrollTop() - 80 }, 100, function () {
                let latoutNode = document.getElementById("tabbox");
                latoutNode.scrollTop = arrGet * 72;
                $("#tabbox .title").removeClass('checked');
                $("#tabbox #tk" + num).addClass('checked');
            })
        } else {
            $("html,body").animate({ scrollTop: $("#t" + num).offset().top - 40 }, 800, function () {
                let latoutNode = document.getElementById("tabbox");
                latoutNode.scrollTop = arrGet * 72;
                $("#tabbox .title").removeClass('checked');
                $("#tabbox #tk" + num).addClass('checked');
            });
        }
    }
    //大类筛选
    onbigfiltrate = (item) => {
        let opt = {};
        this.state.TabItem.forEach((val) => {
            let childlist = val.children;
            childlist.forEach((child) => {
                if (item.bindItemId === child.itemid) {
                    opt = child;
                    return child;
                }
            })
        })
        return opt;
    }

    //筛选添加
    onaddfiltrate = (opt, checkItem) => {
        let cm = this.onbigfiltrate(opt);
        if (Object.keys(cm).length > 0) {
            let num = checkItem.findIndex(value => value.itemid === cm.itemid);
            if (opt.bindId === 0) {
                if (num === -1) {
                    cm.checked = 1;
                    checkItem.push(cm);
                }
                if (cm.bindChildren && cm.bindChildren.length !== 0) {
                    cm.bindChildren.forEach((data) => {
                        checkItem = this.onaddfiltrate(data, checkItem);
                    })
                }
            } else if (opt.bindId === 1) {
                cm.checked = 3;
                if (num !== -1) {
                    checkItem.splice(num, 1);
                }

            }
        }
        return checkItem;
    }
    //筛选减少
    ondelfiltrate = (opt, checkItem) => {
        let cm = this.onbigfiltrate(opt);
        if (Object.keys(cm).length > 0) {
            let num = checkItem.findIndex(value => value.itemid === cm.itemid);
            if (opt.bindId === 0) {
                if (num !== -1 && this.onDepend(this.state.TabItem, cm.itemid) === 0) {
                    cm.checked = 0;
                    checkItem.splice(num, 1);
                }
                if (cm.bindChildren.length !== 0) {
                    cm.bindChildren.forEach((data) => {
                        checkItem = this.ondelfiltrate(data, checkItem);
                    })
                }
            } else if (opt.bindId === 1) {
                if (cm.bindChildren.length !== 0) {
                    if (this.onmutual(cm, checkItem) !== 1) {
                        cm.checked = 0;
                    }
                } else {
                    cm.checked = 0;
                }

            }
        }
        return checkItem;
    }
    //查看依赖项是否存在
    onDepend = (tabitem, itemid) => {
        let cnum = 0;
        tabitem.forEach((item) => {
            item.children.forEach((children) => {
                if (children.bindChildren.length > 0) {
                    let num = children.bindChildren.findIndex(value => value.bindItemId == itemid && value.bindId === 0);
                    if (num !== -1 && children.checked === 1) {
                        cnum = 1;
                        return cnum;
                    }
                    return cnum;
                }
                return cnum;
            })
            return cnum;
        })
        return cnum;
    }
    //查看互斥项是否存在
    onmutual = (item, checkItem) => {
        let cnum = 0;
        item.bindChildren.forEach((val) => {
            let num = checkItem.findIndex(value => value.itemid === val.bindItemId && val.bindId === 1);
            if (num !== -1) {
                cnum = 1;
                return cnum;
            }
            return cnum;
        })

        return cnum;
    }

    getObjects = (obj, key, val) => {
        var objects = [];
        for (var i in obj) {
            if (!obj.hasOwnProperty(i)) continue;
            if (typeof obj[i] == 'object') {
                objects = objects.concat(this.getObjects(obj[i], key, val));
            } else if (i == key && obj[key] == val) {
                if (obj.bindId === 0) {
                    objects.push(obj);
                }
            }
        }
        return objects;
    }
    oncheck = (opt, e) => {
        let checkItem = this.state.checkItem;
        let checkprice = 0;
        let parentItem = this.getObjects(this.state.TabItem, 'bindItemId', opt.itemid);
        if (parentItem.length > 0) {
            for (let i = 0; i < parentItem.length; i++) {
                let num = checkItem.findIndex(value => value.itemid === parentItem[i].mid);
                if (num !== -1) {
                    Toast.info('该项目依赖于项目' + parentItem[i].mname + '，无法修改');
                    return false;
                }
            }
        }
        if (opt.checked === 0) {
            opt.checked = 1;
            checkItem.push(opt);
            if (opt.bindChildren.length !== 0) {
                opt.bindChildren.forEach((data) => {
                    checkItem = this.onaddfiltrate(data, checkItem);
                })
            }
        } else if (opt.checked === 1) {
            let num = checkItem.findIndex(value => value.itemid === opt.itemid);
            opt.checked = 0;
            checkItem.splice(num, 1);
            if (opt.bindChildren.length !== 0) {
                opt.bindChildren.forEach((data) => {
                    checkItem = this.ondelfiltrate(data, checkItem);
                })
            }
        } else if (opt.checked === 2) {
            Toast.info('该项目是医院必选项目，无法修改');
            return;
        } else if (opt.checked === 3) {
            let xm = '';
            this.state.TabItem.forEach((val) => {
                let cm = val.children;
                cm.forEach((val2) => {
                    opt.bindChildren.forEach((data) => {
                        if (data.bindId === 1) {
                            if (val2.itemid === data.bindItemId) {
                                xm = xm + val2.itemname + ','
                            }
                            return true;
                        }
                    })
                })
            })
            Toast.info('该项目与' + xm + "项目互斥，如需选择此项目请先取消选择项目" + xm);
        }
        checkprice = 0;
        checkprice = checkItem.reduce((pre, cur) => {
            return pre + cur.marketprice;
        }, 0);
        this.setState({ checkprice: checkprice, total: checkItem.length, checkItem: checkItem });
    }
    onSelect = (opt) => {
        if (opt.checked === 0) {
            return <img alt='' src={require('../../res/images/check_off.png')} />
        } else if (opt.checked === 1) {
            return <img alt='' src={require('../../res/images/check_on.png')} />
        }
        else if (opt.checked === 2) {
            return <img alt='' src={require('../../res/images/check_de.png')} />
        }
        else if (opt.checked === 3) {
            return <img alt='' src={require('../../res/images/check_ex.png')} />
        }
    };
    showModal = key => (e) => {
        e.preventDefault(); // 修复 Android 上点击穿透
        this.setState({
            [key]: true,
        });
    }

    onClose = key => () => {
        this.setState({
            [key]: false,
        });
    }
    AddCartcustom = () => {
        if (this.state.MinconSumption > this.state.checkprice) {
            Toast.offline('您还没有有达到最低消费标准，请重新选择项目', 2);
            return false;
        }
        //购买自选套餐
        if (this.state.cardid === 0) {
            //加入购物车       
            let data = [];
            this.state.checkItem.forEach(function (v, i) {
                data.push(v.itemid);
            });
            let params = { packId: parseInt(this.state.packageid), items: JSON.stringify(data) };
            services.AddCartcustom(params, '').then(value => {
                if (value.status === 0) {
                    this.onClose('modal1');
                    history.push('/shopping');
                    history.go();

                } else {
                    Toast.offline(value.message);
                    this.onClose('modal1');
                }
            })
        } else {
            //预约自选套餐
            let ids = '';
            let mprice = 0;
            this.state.checkItem.forEach((data, index) => {
                mprice += parseFloat(data.marketprice);
                if (this.state.checkItem.length - 1 === index) {
                    ids += data.itemid;

                } else {
                    ids += data.itemid + ',';
                }
            });
            let orderment = { packageid: '', packageType: 1, ids: ids, cardid: this.state.cardid, mcno: this.state.mcno, payprice: mprice, packagename: '自选1+x套餐' };
            localStorage.setItem('orderment', JSON.stringify(orderment));
            history.push(`/members/orderment/add/${this.state.cardid}/0/null`);
            history.go();
        }

    }


    render() {
        const { TabTitle, TabItem } = this.state;
        return <div className='customa'   >
            <div className="box"  >
                <div className="tabbox" id='tabbox' style={{ height: document.documentElement.clientHeight - cmnum }}    >
                    {
                        !!TabTitle === false ? '' :
                            TabTitle.map((data, index) => (
                                data.num === 0 ? '' :
                                    <div key={index} id={'tk' + index} className={this.state.stylenum === index ? 'title checked' : 'title'}
                                        onClick={this.onTab.bind(this, index)}
                                    >{data.title}</div>
                            ))
                    }
                </div>
                <div className="tabbox2" ></div>
                <div className="itembox" ref={'reftab'} id="reftab" style={{ height: this.props.packageid === 0 ? document.documentElement.clientHeight - 60 : '', overflow: this.props.packageid === 0 ? 'scroll' : '' }}>
                    {
                        TabItem.length === 0 ? ''
                            :
                            TabItem.map((data, index) => (
                                data.children.length === 0 ? '' :
                                    <div className="emptylayer" key={index} id={'t' + index}    >
                                        {
                                            <div>
                                                <div className="tabtitle"   >{data.shortname}({data.children.length})</div>
                                                {TabItem[index].children.map((data2, index2) => (
                                                    <div className="checkline" key={index2}>
                                                        <div className="checklinebox">
                                                            <div className="checkname">{data2.itemname}<span className="ys">{data2.marketprice}</span><span className="ys">
                                                                {!!data2.description === false ? '' :
                                                                    <Popover placement="bottom" content={'项目描述：' + data2.description} trigger="click">
                                                                        <Icon type="info-circle" style={{ fontSize: '10px', color: '#32a128', marginLeft: '3px' }} />
                                                                    </Popover>
                                                                }
                                                            </span>
                                                            </div>
                                                            <div className="check" onClick={this.oncheck.bind(this, data2)}>{this.onSelect(data2)}</div>
                                                        </div>
                                                    </div>
                                                ))
                                                }
                                            </div>
                                        }

                                    </div>
                            ))
                    }

                </div>
            </div>
            <div style={{ height: '50px' }}></div>
            <div className="customafb">
                <div className="fdiv">
                    <div className="ftxt"><span className="sumption">共 {this.state.total} 项
                        {!!this.state.MinconSumption && (this.state.MinconSumption > this.state.checkprice) ? ',自定义套餐最低标准' + this.state.MinconSumption : ''}</span><br></br>合计：<span className="red">{this.state.checkprice}</span>
                        {!!this.state.MinconSumption && (this.state.MinconSumption > this.state.checkprice) ?
                            <span>,离最低标准还差<span className="red">{this.state.MinconSumption - this.state.checkprice}</span></span>
                            : ''
                        }
                    </div>
                    {
                        !!this.state.MinconSumption && (this.state.MinconSumption > this.state.checkprice) ? '' :

                            <Button className="customaBut" onClick={this.showModal('modal1')}>确认</Button>
                    }

                </div>
            </div>
            <Modal id="aaa"
                visible={this.state.modal1}
                transparent
                maskClosable={false}
                onClose={this.onClose('modal1')}
                title="自定义套餐"
                footer={[{ text: '继续修改', onPress: () => { this.onClose('modal1')(); } },
                { text: "确认套餐", onPress: () => { this.AddCartcustom(); } }]}
                wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                afterClose={() => { }}            >
                <div style={{ height: document.documentElement.clientHeight * 0.6, overflow: 'scroll' }}>
                    {
                        this.state.checkItem.length <= 0 ? '' :
                            this.state.checkItem.map((data, index) => (
                                <Tag key={'tag' + index} >{data.itemname}</Tag>
                            ))
                    }
                </div>
            </Modal>
        </div>

    }
}